export default {
    map: state => {
        return Object.fromEntries(state.data.map(item => [item.id, item]));
    },
    getById: getters => id => getters.map[id]
};
